/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLocationFulfillmentAvailabilityRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetLocationFulfillmentAvailabilityResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getLocationFulfillmentAvailability = (request: GetLocationFulfillmentAvailabilityRequest, options?: CashRequestOptions) => post<GetLocationFulfillmentAvailabilityRequest, GetLocationFulfillmentAvailabilityResponse>("/cash-app/local/get-location-fulfillment-availability", request, {...options, rejectOnError: true })